import { NativeObjectTypes } from 'src/lib/objects'

export const tabSetsByObjectType = {
  [NativeObjectTypes.MeetingRecording]: {
    filters: [
      {
        id: 'all',
        label: 'All',
        filterItems: [],
      },
      {
        id: 'ready',
        label: 'Ready',
        filterItems: [
          {
            id: 'ready',
            field: 'statusLabel',
            operator: 'is',
            value: 'READY',
          },
        ],
      },
      {
        id: 'processing',
        label: 'Processing',
        filterItems: [
          {
            id: 'processing',
            field: 'statusLabel',
            operator: 'is',
            value: 'PROCESSING',
          },
        ],
      },
      {
        id: 'failed',
        label: 'Did not record',
        filterItems: [
          {
            id: 'notReady',
            field: 'statusLabel',
            operator: 'not',
            value: 'READY',
          },
          {
            id: 'notProcessing',
            field: 'statusLabel',
            operator: 'not',
            value: 'PROCESSING',
          },
        ],
      },
      {
        id: 'user-meetings',
        label: 'Your meetings',
        filterItems: [
          {
            id: 'user-meetings',
            field: 'userWasInMeeting',
            operator: 'is',
            value: 'true',
          },
        ],
      },
    ],
  },
}
